'use client';

import { styled } from '@mui/material/styles';

export const HomeRoot = styled('section')(({ theme }) => ({
  width: '100%',
  boxSizing: 'border-box',
  paddingLeft: 'clamp(16px, 5.56vw, 80px)',
  paddingRight: 'clamp(16px, 5.56vw, 80px)',
  paddingTop: 'clamp(24px, 10.42vw, 150px)',
  paddingBottom: 'clamp(20px, 4.2vw, 60px)',
  [theme.breakpoints.between(900, 1200)]: {
    paddingLeft: 'clamp(16px, 4vw, 64px)',
    paddingRight: 'clamp(16px, 4vw, 64px)',
    paddingTop: 'clamp(18px, 7vw, 120px)',
    paddingBottom: 'clamp(18px, 3.8vw, 52px)',
  },
  [theme.breakpoints.between(600, 899)]: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 32,
    paddingBottom: 32,
  },
  [theme.breakpoints.down(600)]: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 24,
    paddingBottom: 28,
  },
}));

export const HomeInner = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 1440,
  marginInline: 'auto',
  position: 'relative',
  minHeight: 'clamp(360px, 36.94vw, 532px)',
  [theme.breakpoints.between(900, 1200)]: {
    minHeight: 'clamp(320px, 33vw, 500px)',
  },
  [theme.breakpoints.down(900)]: {
    minHeight: 'unset',
    display: 'flex',
    flexDirection: 'column',
    gap: 18,
  },
}));

export const ImageWrap = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  width: 973.05,
  marginRight: -76,
  aspectRatio: '973.05 / 531.9',
  maxWidth: '100%',
  marginTop: -150,
  zIndex: 1,
  '& > a': {
    position: 'absolute',
    inset: 0,
    display: 'block',
  },
  [theme.breakpoints.between(900, 1200)]: {
    width: 'clamp(520px, 58vw, 820px)',
    marginRight: 'clamp(-40px, -6vw, -70px)',
    marginTop: 'clamp(-90px, -9vw, -150px)',
  },
  [theme.breakpoints.down(900)]: {
    position: 'relative',
    right: 'auto',
    top: 'auto',
    width: 'min(980px, 92vw)',
    marginRight: 0,
    marginTop: 12,
    order: 2,
  },
  [theme.breakpoints.down(600)]: {
    width: '92vw',
  },
}));

export const HeroImage = styled('img')({
  objectFit: 'contain',
  width: '100%',
  height: '100%',
});

export const ContentWrap = styled('div')(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  width: 760,
  maxWidth: '100%',
  marginTop: 'clamp(18px, 6.25vw, 90px)',
  [theme.breakpoints.between(900, 1200)]: {
    width: 'min(680px, 56vw)',
    marginTop: 'clamp(12px, 4.8vw, 64px)',
  },
  [theme.breakpoints.down(900)]: {
    width: '100%',
    marginTop: 0,
    display: 'contents',
  },
}));

export const TitleWrap = styled('div')(({ theme }) => ({
  width: 290.54,
  maxWidth: '100%',
  [theme.breakpoints.between(900, 1200)]: {
    width: 'clamp(240px, 24vw, 290.54px)',
  },
  [theme.breakpoints.down(900)]: {
    width: 'min(320px, 92vw)',
    order: 1,
  },
}));

export const WelcomeText = styled('div')(({ theme }) => ({
  fontFamily: 'Lufga, sans-serif',
  fontWeight: 300,
  fontSize: 40,
  lineHeight: 1,
  letterSpacing: 0,
  color: 'rgba(15, 82, 186, 1)',
  [theme.breakpoints.between(900, 1200)]: {
    fontSize: 'clamp(30px, 3.2vw, 40px)',
  },
  [theme.breakpoints.between(600, 899)]: {
    fontSize: 32,
  },
  [theme.breakpoints.down(600)]: {
    fontSize: 28,
  },
}));

export const BrandMarkWrap = styled('div')(({ theme }) => ({
  position: 'relative',
  width: 'clamp(180px, 16.25vw, 234px)',
  height: 'clamp(40px, 3.61vw, 52px)',
  marginTop: 6,
  [theme.breakpoints.between(600, 899)]: {
    width: 210,
    height: 46,
  },
  [theme.breakpoints.down(600)]: {
    width: 190,
    height: 44,
  },
}));

export const BrandMark = styled('img')({
  objectFit: 'contain',
  width: '100%',
  height: '100%',
});

export const CopyWrap = styled('div')(({ theme }) => ({
  width: 759.82,
  maxWidth: '100%',
  marginTop: 50,
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
  [theme.breakpoints.between(900, 1200)]: {
    width: 'min(640px, 56vw)',
    marginTop: 28,
  },
  [theme.breakpoints.down(900)]: {
    width: '100%',
    marginTop: 18,
    order: 3,
  },
}));

export const CopyText = styled('p')(({ theme }) => ({
  margin: 0,
  fontFamily: 'Open Sans, sans-serif',
  fontWeight: 400,
  fontSize: 18,
  lineHeight: '125%',
  letterSpacing: 0,
  color: 'rgba(0, 0, 0, 0.72)',
  [theme.breakpoints.between(900, 1200)]: {
    fontSize: 'clamp(15px, 1.6vw, 18px)',
  },
  [theme.breakpoints.between(600, 899)]: {
    fontSize: 16,
  },
  [theme.breakpoints.down(600)]: {
    fontSize: 15,
  },
}));

export const EmOrder = styled('span')(({ theme }) => ({
  fontFamily: 'Outfit, sans-serif',
  fontWeight: 600,
  fontSize: 18,
  lineHeight: '125%',
  letterSpacing: 0,
  color: 'rgba(0, 0, 0, 0.78)',
  [theme.breakpoints.between(900, 1200)]: {
    fontSize: 'clamp(15px, 1.6vw, 18px)',
  },
  [theme.breakpoints.between(600, 899)]: {
    fontSize: 16,
  },
  [theme.breakpoints.down(600)]: {
    fontSize: 15,
  },
}));

export const EmX = styled('span')(({ theme }) => ({
  fontFamily: 'Outfit, sans-serif',
  fontWeight: 600,
  fontSize: 18,
  lineHeight: '125%',
  letterSpacing: 0,
  color: 'rgba(15, 82, 186, 1)',
  [theme.breakpoints.between(900, 1200)]: {
    fontSize: 'clamp(15px, 1.6vw, 18px)',
  },
  [theme.breakpoints.between(600, 899)]: {
    fontSize: 16,
  },
  [theme.breakpoints.down(600)]: {
    fontSize: 15,
  },
}));

export const ButtonRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  marginTop: 40,
  [theme.breakpoints.down(900)]: {
    marginTop: 18,
    order: 4,
  },
  [theme.breakpoints.down(600)]: {
    gap: 10,
    marginTop: 18,
  },
}));

export const PrimaryBtn = styled('a')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 54,
  paddingLeft: 40,
  paddingRight: 40,
  borderRadius: 27,
  backgroundColor: 'rgba(0, 53, 114, 1)',
  color: 'rgba(255, 255, 255, 1)',
  textDecoration: 'none',
  fontFamily: 'Outfit, sans-serif',
  fontWeight: 400,
  fontSize: 20,
  lineHeight: '122%',
  letterSpacing: 0,
  [theme.breakpoints.between(900, 1200)]: {
    height: 50,
    paddingLeft: 34,
    paddingRight: 34,
    fontSize: 18,
  },
  [theme.breakpoints.between(600, 899)]: {
    height: 50,
    paddingLeft: 34,
    paddingRight: 34,
    fontSize: 18,
  },
  [theme.breakpoints.down(600)]: {
    height: 48,
    paddingLeft: 30,
    paddingRight: 30,
    fontSize: 17,
  },
}));

export const OutlineBtn = styled('a')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 54,
  paddingLeft: 40,
  paddingRight: 40,
  borderRadius: 27,
  backgroundColor: 'transparent',
  color: 'rgba(255, 137, 0, 1)',
  border: '2px solid rgba(255, 137, 0, 1)',
  textDecoration: 'none',
  fontFamily: 'Outfit, sans-serif',
  fontWeight: 400,
  fontSize: 20,
  lineHeight: '122%',
  letterSpacing: 0,
  [theme.breakpoints.between(900, 1200)]: {
    height: 50,
    paddingLeft: 34,
    paddingRight: 34,
    fontSize: 18,
  },
  [theme.breakpoints.between(600, 899)]: {
    height: 50,
    paddingLeft: 34,
    paddingRight: 34,
    fontSize: 18,
  },
  [theme.breakpoints.down(600)]: {
    height: 48,
    paddingLeft: 30,
    paddingRight: 30,
    fontSize: 17,
  },
}));
